import * as Yup from 'yup'

import { CUSTOM_AGE_RANGES } from '../../../../../ReusableFormFields/AgeRangesFields/fields'
import { customAgeRangesValidation } from '../../../LineItemDv360Create/LineItemDv360CreateForm/LineItemDV360AgeForm/fields'
import {
  AGE_RANGE_18_24,
  AGE_RANGE_25_34,
  AGE_RANGE_35_44,
  AGE_RANGE_45_54,
  AGE_RANGE_55_64,
  AGE_RANGE_65_PLUS
} from '../../../../fields'

const isAgeRangeChecked = (targeting, ageRange) => !!targeting.find(item => item.age_range === ageRange)

export const getInitialValues = targeting => {
  return {
    [CUSTOM_AGE_RANGES]: {
      [AGE_RANGE_18_24]: isAgeRangeChecked(targeting, AGE_RANGE_18_24),
      [AGE_RANGE_25_34]: isAgeRangeChecked(targeting, AGE_RANGE_25_34),
      [AGE_RANGE_35_44]: isAgeRangeChecked(targeting, AGE_RANGE_35_44),
      [AGE_RANGE_45_54]: isAgeRangeChecked(targeting, AGE_RANGE_45_54),
      [AGE_RANGE_55_64]: isAgeRangeChecked(targeting, AGE_RANGE_55_64),
      [AGE_RANGE_65_PLUS]: isAgeRangeChecked(targeting, AGE_RANGE_65_PLUS)
    }
  }
}

export const validationSchema = Yup.object({
  [CUSTOM_AGE_RANGES]: Yup.object().test(customAgeRangesValidation)
})
